var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserManagemenntNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_811_6357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 13.3428C13.8542 13.3428 15.3572 11.8398 15.3572 9.98568C15.3572 8.13159 13.8542 6.62854 12.0001 6.62854C10.146 6.62854 8.64294 8.13159 8.64294 9.98568C8.64294 11.8398 10.146 13.3428 12.0001 13.3428Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26599 18.58C6.86523 17.5964 7.70743 16.7834 8.71162 16.2194C9.7158 15.6552 10.8482 15.3589 12 15.3589C13.1518 15.3589 14.2842 15.6552 15.2884 16.2194C16.2926 16.7834 17.1347 17.5964 17.734 18.58",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 20.7286C16.8208 20.7286 20.7286 16.8207 20.7286 12C20.7286 7.17934 16.8208 3.27142 12.0001 3.27142C7.1794 3.27142 3.27148 7.17934 3.27148 12C3.27148 16.8207 7.1794 20.7286 12.0001 20.7286Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_811_6357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManagemenntNew);
export default __webpack_public_path__ + "static/media/UserManagemenntNew.e1436f0bcf56997ea13cdaedff605f75.svg";
export { ForwardRef as ReactComponent };